import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import RefferSection from "../common/RefferSection";
import "react-image-gallery/styles/css/image-gallery.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./index.css";
import { useSelector, useDispatch } from "react-redux";
import { getApi } from "../../actions/structure.action";
import isEmpty from "../../utils/is-Empty";
import { Link, useNavigate, useParams } from "react-router-dom";
import OrderSummaryCard from "../Cart/OrderSummaryCard";
import Spinner from "../common/Spinner";
import TimestampConverter from "../../utils/TimestampConverter";
import axios from "axios";
import { BHAREE_BASE_URL_LOCAL } from "../../config/config.url";
import { appConstants } from "../../helpers/app-constants";
import PageSpinner from "../common/PageSpinner";
import { useDialog } from "../../helpers/useDialog";
import StatusBadge from "../Account/StatusBadge";

const Order = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { alert, confirm, DialogModal } = useDialog();
  const { id } = useParams();
  const { currentOrder } = useSelector((state) => {
    return state;
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    getApi("getOrder", dispatch, "/" + id);
  }, [id, dispatch]);

  const SummaryBox = () => {
    if (!isEmpty(currentOrder.data)) {
      return (
        <>
          <p className="m-0">{"Order Summary"}</p>
          <Row className="price-box mx-0 my-2">
            <Col xs={4}></Col>
            <Col xs={5} className="title p-0">
              {"Subtotal:"}
            </Col>
            <Col xs={3} className="amount p-0">
              {currentOrder?.data?.totalAmount} &nbsp;{"₹"}
            </Col>
          </Row>
          <Row className="price-box mx-0 my-2">
            <Col xs={4}></Col>
            <Col xs={5} className="title p-0">
              {"Delivery Charges:"}
            </Col>
            <Col xs={3} className="amount p-0">
              {currentOrder?.data?.totalDelivery} &nbsp;{"₹"}
            </Col>
          </Row>
          <Row className="price-box mx-0 my-2">
            <Col xs={4}></Col>
            <Col xs={5} className="title p-0">
              {"Handling Charges:"}
            </Col>
            <Col xs={3} className="amount p-0">
              {currentOrder?.data?.totalHandlingCharges} &nbsp;{"₹"}
            </Col>
          </Row>
          <Row className="price-box mx-0 my-2">
            <Col xs={4}></Col>
            <Col xs={8} className="title p-0">
              <hr className="mx-0 cutomeHR" />
            </Col>
          </Row>
          <Row className="price-box mx-0 my-2">
            <Col xs={4}></Col>
            <Col xs={5} className="amount strong p-0">
              {"Payable Amount:"}
            </Col>
            <Col xs={3} className="amount strong p-0">
              {/* {parseFloat(checkoutItems?.data.payableAmount).toFixed(2)|| 0}&nbsp;{"₹"} */}
              {currentOrder?.data?.payableAmount} &nbsp;{"₹"}
            </Col>
          </Row>
        </>
      );
    }
  };

  const orderBanner = (
    <div className="order-banner-main-div text-uppercase desktop">
      <p>
        {" "}
        <Link to={`/`}>{"Home "}</Link>
      </p>
      <h2>{"Order"}</h2>
    </div>
  );

  const handlePayNow = () => {
    dispatch({ type: appConstants.ORDER_PAYMENT_LINK_LOADING, payload: true });
    setLoading(true);
    axios
      .get(`${BHAREE_BASE_URL_LOCAL}/orders/get-payment-link/${currentOrder?.data?.id}`, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.jwtToken}`,
        },
      })
      .then(async (response) => {
        setLoading(false);
        dispatch({ type: appConstants.ORDER_PAYMENT_LINK_LOADING, payload: false });
        if (response?.data?.data?.short_url) {
          window.location.href = response.data.data.short_url;
        } else {
          await alert("Failed to get payment link.");
        }
      })
      .catch(async (err) => {
        setLoading(false);
        console.error("Error fetching payment link:", err);
        await alert("Error fetching payment link.");
        dispatch({ type: appConstants.ORDER_PAYMENT_LINK_LOADING, payload: false });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDownloadInvoice = () => {
    navigate(`/invoice/${currentOrder?.data?.id}`);
  };

  return (
    <section className="order-main-section">
      {DialogModal}
      {loading && <PageSpinner />}
      {orderBanner}
      {(() => {
        if (!currentOrder.loading && !isEmpty(currentOrder?.data)) {
          return (
            <Container className="py-4">
              <div className="order-section-title-div">
                <h4 className="order-section-title m-0">{"Order Details"}</h4>
              </div>
              <div id="borderLeft"></div>

              <Row className="m-0 py-2 order-info">
                <Col xs={12} sm={12} md={8} lg={8} className="p-0 text-start">
                  <div>
                    <p className="m-0">
                      Order ID: <span># {currentOrder?.data?.orderId}</span>
                      {" | "}
                      Status: <StatusBadge status={currentOrder?.data?.status} />{" "}
                    </p>
                  </div>
                </Col>
                <Col xs={12} sm={12} md={4} lg={4} className="p-0  left-col">
                  <div>
                    <p className="m-0">
                      Order Placement Date:{" "}
                      <span>{TimestampConverter(currentOrder?.data?.order_date)}</span>{" "}
                    </p>
                  </div>
                </Col>
              </Row>
              <Row className="m-0 py-2">
                <Col xs={12} sm={12} md={8} lg={8} className="p-0">
                  {/* <OrderSummaryCard card={currentOrder?.data?.product_variant_id[0]} crud={false} /> */}
                  {/* {!isEmpty(cardItem) && } */}
                  <OrderSummaryCard
                    card={currentOrder?.data}
                    crud={false}
                    currentOrderView={true}
                  />
                </Col>

                <Col xs={12} sm={12} md={4} lg={4} className="order-summery-price p-0">
                  {SummaryBox()}
                </Col>
                <Col xs={12} sm={12} md={8} lg={8} className="p-0 text-start">
                  <div>
                    <p className="m-0">
                      <strong>{"Expected Delivery Date:"}</strong>{" "}
                      <span>
                        {" "}
                        {TimestampConverter(currentOrder?.data?.expected_delivery_date, true)}
                      </span>{" "}
                    </p>
                    {!isEmpty(currentOrder?.data?.accepted_at) && (
                      <p className="m-0">
                        <strong>{"Confirmed Date:"}</strong>{" "}
                        <span> {TimestampConverter(currentOrder?.data?.accepted_at, true)}</span>{" "}
                      </p>
                    )}
                    {!isEmpty(currentOrder?.data?.shipped_at) && (
                      <p className="m-0">
                        <strong>{"Assigned to LP Date:"}</strong>{" "}
                        <span> {TimestampConverter(currentOrder?.data?.shipped_at, true)}</span>{" "}
                      </p>
                    )}
                    {!isEmpty(currentOrder?.data?.outfordelivery_at) && (
                      <p className="m-0">
                        <strong>{"Out for Delivery Date:"}</strong>{" "}
                        <span>
                          {" "}
                          {TimestampConverter(currentOrder?.data?.outfordelivery_at, true)}
                        </span>{" "}
                      </p>
                    )}
                    {!isEmpty(currentOrder?.data?.delivered_at) && (
                      <p className="m-0">
                        <strong>{"Delivered Date:"}</strong>{" "}
                        <span> {TimestampConverter(currentOrder?.data?.delivered_at, true)}</span>{" "}
                      </p>
                    )}
                  </div>
                </Col>
                <Col xs={12} sm={12} md={4} lg={4} className="p-0  left-col">
                  <div>
                    <p className="m-0">
                      <strong>Payment Status:</strong>{" "}
                      {(() => {
                        if (currentOrder?.data?.payment_status_id === "success") {
                          return (
                            <span class="text-uppercase text-success">
                              {currentOrder?.data?.payment_status_id}
                            </span>
                          );
                        } else if (currentOrder?.data?.payment_status_id === "pending") {
                          return (
                            <span class="text-uppercase text-warning">
                              {currentOrder?.data?.payment_status_id}
                            </span>
                          );
                        } else {
                          return (
                            <span class="text-uppercase text-danger">
                              {currentOrder?.data?.payment_status_id}
                            </span>
                          );
                        }
                      })()}
                    </p>
                    {currentOrder?.data?.payment_status_id !== "success" && (
                      <Button className="btn btn-primary mt-1" onClick={handlePayNow}>
                        <i class="bi bi-currency-rupee"></i> Pay Now
                      </Button>
                    )}
                    {currentOrder?.data?.payment_status_id === "success" && (
                      <Button className="btn btn-primary mt-1" onClick={handleDownloadInvoice}>
                        <i class="bi bi-receipt"></i> Invoice
                      </Button>
                    )}
                  </div>
                </Col>
              </Row>
              <div className="order-section-title-div mt-2">
                <h4 className="order-section-title m-0">{"Delivery Address"}</h4>
              </div>
              <div id="borderLeft"></div>
              <Row className="m-0 py-2 order-info">
                <Col xs={12} sm={12} md={8} lg={8} className="p-0 text-start">
                  <div>
                    <div>
                      <p className="m-0">
                        <span>{currentOrder?.data?.buyerInfo?.business_name}</span>
                      </p>
                    </div>
                    <p className="m-0">
                      {" "}
                      <span>
                        {" "}
                        {currentOrder?.data?.delivery_address_id?.address_line_1}
                        {!isEmpty(currentOrder?.data?.delivery_address_id?.address_line_2)
                          ? ", " + currentOrder?.data?.delivery_address_id?.address_line_2
                          : ""}
                        {!isEmpty(currentOrder?.data?.delivery_address_id?.address_line_3)
                          ? ", " + currentOrder?.data?.delivery_address_id?.address_line_3
                          : ""}{" "}
                      </span>
                    </p>
                  </div>
                  <div>
                    <p className="m-0">
                      City :<span> {currentOrder?.data?.delivery_address_id?.city}</span>
                    </p>
                  </div>
                  <div>
                    <p className="m-0">
                      State:<span> {currentOrder?.data?.delivery_address_id?.state} </span>
                    </p>
                  </div>
                  <div>
                    <p className="m-0">
                      Country:<span> {currentOrder?.data?.delivery_address_id?.country} </span>
                    </p>
                  </div>

                  <div>
                    <p className="m-0">
                      Pin code: <span>{currentOrder?.data?.delivery_address_id?.pin_code}</span>
                    </p>
                  </div>
                </Col>
                {/* <Col xs={12} sm={12} md={4} lg={4} className="p-0 left-col">
                  <div>
                    <p className="m-0">
                      Buyer Name : <span>{currentOrder?.data?.buyerInfo?.business_name}</span>
                    </p>
                  </div>
                  <div>
                    <p className="m-0">
                      Contact Number :{" "}
                      <span>{currentOrder?.data?.delivery_address_id?.primary_number}</span>
                    </p>
                  </div>
                </Col> */}
              </Row>

              {/* pikup addresses

            <div className="order-section-title-div">
              <h4 className="order-section-title m-0">{"Pick Up Address"}</h4>
            </div>
            <div id="borderLeft"></div>
            <Row className="m-0 py-2 order-info">
              <Col xs={12} sm={12} md={8} lg={8} className="p-0 text-start">
                <div><p className="m-0"> <span> {currentOrder?.data?.seller_address_id?.address_line_1},{currentOrder?.data?.seller_address_id?.address_line_2},{currentOrder?.data?.seller_address_id?.address_line_3} </span></p></div>
                <div><p className="m-0">City :<span> {currentOrder?.data?.seller_address_id?.city}</span></p></div>
                <div><p className="m-0">State:<span> {currentOrder?.data?.seller_address_id?.state}  </span></p></div>
                <div><p className="m-0">Country:<span> {currentOrder?.data?.seller_address_id?.country} </span></p></div>

                <div><p className="m-0">Pin code: <span>{currentOrder?.data?.seller_address_id?.pin_code}</span></p></div>
              </Col>
              <Col xs={12} sm={12} md={4} lg={4} className="p-0  left-col">
                <div><p className="m-0">Seller : <span>{currentOrder?.data?.seller_address_id?.full_name}</span></p></div>
                <div><p className="m-0">Seller contact Number : <span>{currentOrder?.data?.seller_address_id?.primary_number}</span></p></div>
              </Col>
            </Row> */}
            </Container>
          );
        } else if (currentOrder.loading) {
          return <Spinner />;
        }
      })()}

      <RefferSection />
    </section>
  );
};

export default Order;
